import { ManagersService } from '@/services/managers.service'
import getFullName from '@/utils/getFullName.js'

export async function banManager() {
  try {
    const result = await this.$swal.fire({
      title: 'Блокировка сотрудника',
      text: `Сотрудник ${getFullName(this.row)} будет заблокирован.`,
      showCancelButton: true,
      confirmButtonText: 'Блокировать',
      showLoaderOnConfirm: true,
      preConfirm: () => {
        return ManagersService.destroy({ id: this.row.id }).catch((error) => {
          this.$store.commit('toast/NEW', { type: 'error', message: error.message })
          return false
        })
      },
      allowOutsideClick: !this.$swal.isLoading,
    })
    if (result.isConfirmed) {
      this.$store.commit('toast/NEW', { type: 'success', message: 'Операция выполнена.' })
      this.$bus.$emit('refresh-managers-table')
    }
  } catch (e) {
    this.$store.commit('toast/NEW', { type: 'error', message: e.message, e })
    this.error = e.message
  }
}

export async function unbanManager() {
  try {
    const result = await this.$swal.fire({
      title: 'Разблокировка сотрудника',
      text: `Сотрудник ${getFullName(this.row)} будет разблокирован.`,
      showCancelButton: true,
      confirmButtonText: 'Разблокировать',
      showLoaderOnConfirm: true,
      preConfirm: () => {
        return ManagersService.restore({ id: this.row.id }).catch((error) => {
          this.$store.commit('toast/NEW', { type: 'error', message: error.message })

          return false
        })
      },
      allowOutsideClick: !this.$swal.isLoading,
    })

    if (result.isConfirmed) {
      this.$store.commit('toast/NEW', { type: 'success', message: 'Операция выполнена.' })
      this.$bus.$emit('refresh-managers-table')
    }
  } catch (e) {
    this.$store.commit('toast/NEW', { type: 'error', message: e.message, e })
    this.error = e.message
  }
}
